export default "__VITE_ASSET__eba36c2f__"